//
import React from 'react';
import { StyleProp, StyleSheet, Text, ViewStyle } from 'react-native';
import colors from '../../colors';
import { PLAY_STORE_URL } from '../../shared/constants';

import Touchable from './Touchable';
import { Entypo } from '@expo/vector-icons';
import * as Linking from 'expo-linking';

type Props = {};

const PlayStoreButton: React.FC<Props> = (props) => {
  const openPlayStore = () => {
    Linking.openURL(PLAY_STORE_URL);
  };
  return (
    <Touchable style={styles.btn} onPress={openPlayStore}>
      <Entypo name="google-play" size={30} color={'#fff'} />
      <Text style={{ color: '#fff', fontWeight: '700' }}>Baixar na Play Store</Text>
    </Touchable>
  );
};

const styles = StyleSheet.create({
  btn: {
    flex: 1,
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: colors.green,
    padding: 5,
    borderRadius: 5,
    margin: 10
  }
});

export default PlayStoreButton;
